module.exports = __webpack_public_path__ + "static/media/spinner.55d905f7.gif";